import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { Organization } from 'pages/organization/Organization'
import { z } from 'zod'

const parseParams = z.object({
  orgID: z.string(),
})

const searchParams = z.object({
  mode: z.enum(['edit']),
})

export const Route = createFileRoute('/organization/$orgID')({
  component: Organization,
  params: {
    parse: (params) => parseParams.parse(params),
  },
  validateSearch: zodValidator(searchParams),
})
